/**
 * Platform Detection Service
 * Detects whether the app is running on web, iOS, or Android
 */

import { Capacitor } from '@capacitor/core';

export type PlatformType = 'web' | 'ios' | 'android';

export class PlatformService {
  /**
   * Check if running as a native app
   */
  static isNative(): boolean {
    return Capacitor.isNativePlatform();
  }

  /**
   * Get the current platform
   */
  static getPlatform(): PlatformType {
    return Capacitor.getPlatform() as PlatformType;
  }

  /**
   * Check if running on iOS
   */
  static isIOS(): boolean {
    return Capacitor.getPlatform() === 'ios';
  }

  /**
   * Check if running on Android
   */
  static isAndroid(): boolean {
    return Capacitor.getPlatform() === 'android';
  }

  /**
   * Check if running on web
   */
  static isWeb(): boolean {
    return Capacitor.getPlatform() === 'web';
  }

  /**
   * Check if a specific plugin is available
   */
  static isPluginAvailable(pluginName: string): boolean {
    return Capacitor.isPluginAvailable(pluginName);
  }

  /**
   * Get platform-specific configuration
   */
  static getPlatformConfig() {
    const platform = this.getPlatform();
    return {
      platform,
      isNative: this.isNative(),
      supportsHaptics: this.isNative(),
      supportsBackButton: this.isAndroid(),
      supportsStatusBar: this.isNative(),
      supportsKeyboard: this.isNative(),
    };
  }
}
